var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { attrs: { id: "container-wrap" } },
    [
      _c(
        "section",
        { attrs: { id: "content" } },
        [
          _c("Header", {
            attrs: { status: _vm.status },
            on: { message: _vm.handlePopupMessage },
          }),
          _vm._v(" "),
          _vm.status == "signin"
            ? _c("Signin", {
                ref: "signin",
                on: {
                  message: _vm.handlePopupMessage,
                  complete: _vm.handleCouponComplete,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.status == "coupon"
            ? _c("Register", {
                on: {
                  message: _vm.handlePopupMessage,
                  complete: _vm.handleCouponComplete,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.status == "complete"
            ? _c("Complete", { attrs: { code: _vm.completeCouponCode } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.message != ""
        ? _c("Popup", {
            attrs: { message: _vm.message },
            on: { message: _vm.handlePopupMessage },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }